import { TrainingProgramsConfig } from 'modules/settings/pods/settings-training-settings/domain';
import { AppSettingsConfig, TenantConfig } from './app-settings.model';

export const DEFAULT_TENANT_CONFIG: TenantConfig = {
    zoneId: 'Europe/Madrid',
};

export const DEFAULT_TRAINING_PROGRAMS_CONFIG: TrainingProgramsConfig = {
    applicableLocationsConfig: {
        enableApplicableLocations: false,
    },
    trainerAppConfig: {
        allowActions: true,
        enableTrainerSignature: false,
        enableOperatorSignature: false,
        enableUploadEvidence: false,
        taskTypesWithEvidence: [],
    },
};

export const DEFAULT_APP_SETTINGS_CONFIG: AppSettingsConfig = {
    tenantConfig: DEFAULT_TENANT_CONFIG,
    trainingProgramsConfig: DEFAULT_TRAINING_PROGRAMS_CONFIG,
};
